var findNextEnabledIndex = function (direction, ineligibleDays, isDisabled, numbersLength, startIndex) {
    var currentIndex = startIndex;
    var step = direction === 'right' ? 1 : -1;
    var isDayDisabled = function (num) { return isDisabled(num, ineligibleDays); };
    while (currentIndex >= 0 && currentIndex < numbersLength) {
        if (!isDayDisabled(currentIndex)) {
            return currentIndex;
        }
        currentIndex += step;
    }
    return startIndex - step;
};
export default findNextEnabledIndex;
